import { LockIcon } from "@/assets";
import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  changeStatus,
  changeStatusGroup,
  generateTempCode,
  getAdmins,
} from "../api/admins";
import {
  changeStatusGroupLeader,
  generateTempCodeForGroup,
  getGroupAdminInfo,
  getGroupLeaderInfo,
  getGroupsUsers,
  setOldTripsCount,
} from "../api/group";
import { userReport } from "../api/jahadgar";
import { getToken } from "../api/token";
import AccessibilityIcon from "../assets/SVG/accessibilityIcon";
import EyeOpenIcon from "../assets/SVG/eyeOpenIcon";
import SelectionFuncTable from "./accontsTable/selectionFuncTable";
import CustomTable from "./customTable/CustomTable";
import { Loader } from "./loader";
import ViewProfile from "./profile/viewProfile";
import SearchInput from "./project/searchInput";
import { Form, Formik } from "formik";
import { AsarFormikInput } from "./asarInput";

const bloodTypeKeyVals = [
  { key: "A_PLUS", value: "+A" },
  { key: "A_MINUS", value: "-A" },
  { key: "B_PLUS", value: "+B" },
  { key: "B_MINUS", value: "-B" },
  { key: "AB_MINUS", value: "-AB" },
  { key: "AB_PLUS", value: "+AB" },
  { key: "O_PLUS", value: "+O" },
  { key: "O_MINUS", value: "-O" },
];

const validationSchema = Yup.object({
  oldTripsCount: Yup.string()
    .required("تعداد اردوهای شرکت کرده الزامی است")
    .min(0, "تعداد اردوهای شرکت کرده حداقل باید 0 باشد")
    .max(100000, "تعداد اردوهای شرکت کرده باید حداکثر 100000 باشد"),
});

export default function AdminTable({ selected, dataGroup }) {
  const [valueSearch, setValueSearch] = useState("");
  const [rowData, setRowData] = useState([]);
  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalSize, setTotalSize] = useState();
  const [lastFetch, setLastFetch] = useState();

  const [openProfilePop, setOpenProfilePop] = useState();
  const [dataMyInfo, setDataMyInfo] = useState();
  const [image, setImage] = useState();
  const [groupInfo, setGroupInfo] = useState();

  const [selection, setSelection] = React.useState([]);
  const [loading, setLoading] = useState();
  const [clearSelectionFlag, setClearSelectionFlag] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  // Column Definitions: Defines & controls grid columns.
  const [colDefs, colDefsGroups] = useMemo(
    () => [
      [
        {
          field: "name",
          headerName: "نام مسئول",
          width: 200,
          headerCheckboxSelection: true,
          checkboxSelection: true,
        },
        // {
        //   headerName: "جنسیت",
        //   width: 100,
        //   cellRenderer: (x, options = {}) => {
        //     const isMobile = options.mobile ?? false;
        //     return (
        //       <Box
        //         key={`sex_${x.id}`}
        //         display="flex"
        //         alignItems="center"
        //         justifyContent={isMobile ? "end" : ""}
        //       >
        //         {x.data.sex === "MALE" && <MaleIcon size="0.5" />}
        //         {x.data.sex !== "MALE" && <FemaleIcon size="0.5" />}
        //         <Typography fontFamily="Vazirmatn">
        //           {x.data.sex === "MALE" ? "مرد" : "زن"}
        //         </Typography>
        //       </Box>
        //     );
        //   },
        // },
        {
          field: "fatherName",
          headerName: "نام پدر",
          width: 100,
        },
        {
          field: "groupName",
          headerName: "گروه",
          width: 150,
        },
        {
          field: "nid",
          headerName: "کد ملی",
          width: 120,
        },
        {
          field: "university",
          headerName: "دانشگاه",
          width: 130,
        },
        {
          field: "phone",
          headerName: "شماره تلفن",
          width: 130,
        },
        {
          field: "birthDay",
          headerName: "تاریخ تولد",
          width: 120,
        },
        {
          field: "field",
          headerName: "رشته تحصیلی",
          width: 150,
        },
        {
          field: "oldTripsCount",
          headerName: "اردوهای اولیه",
          width: 140,
        },
        {
          headerName: "وضعیت",
          width: 120,
          cellRenderer: (x) => {
            return (
              <Typography
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
                key={`status_${x.id}`}
              >
                {x.data.status === "PENDING"
                  ? "در حال بررسی"
                  : x.data.status === "ACTIVE"
                    ? "فعال"
                    : "غیرفعال"}
              </Typography>
            );
          },
        },
        // {
        //   headerName: "اطلاعات آشنایان",
        //   width: 300,
        //   cellRenderer: (x) => {
        //     return (
        //       <Typography
        //         fontFamily="Vazirmatn"
        //         sx={{ lineHeight: "unset" }}
        //         key={`nearby_${x.id}`}
        //       >
        //         {x.data.nearbyPhone && x.data.nearbyRel && x.data.nearbyName
        //           ? `${x.data.nearbyName} / ${x.data.nearbyRel} / ${x.data.nearbyPhone}`
        //           : ""}
        //       </Typography>
        //     );
        //   },
        // },
        {
          headerName: "عملیات",
          width: 400,
          cellRenderer: (x) => {
            return (
              <Grid key={`operation_${x.data.id}`} display={"flex"} gap={"5px"}>
                {selected === 4 && (
                  <Button
                    style={{ fontFamily: "Vazirmatn" }}
                    variant="outlined"
                    onClick={() => setSelectedRow(x.data)}
                  >
                    تنظیم تعداد اردو اولیه
                  </Button>
                )}

                <Box
                  bgcolor={x.data.status === "PENDING" ? "#682C54" : "#F05542"}
                  gap="9px"
                  width="fit-content"
                  px="9px"
                  display="flex"
                  alignItems="center"
                  borderRadius="9px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    if (selected === 4) {
                      changeStatusGroupLeader(
                        x.data.id,
                        x.data.status === "PENDING" ? "ACTIVE" : "PENDING",
                      )
                        .then(() => {
                          if (x.data.status === "PENDING")
                            toast.success("اجازه دسترسی با موفقیت انجام شد");
                          else toast.success("لغو دسترسی با موفقیت انجام شد");
                          setRowData((data) =>
                            data.map((z) =>
                              z.id === x.data.id
                                ? {
                                    ...z,
                                    status:
                                      x.data.status === "PENDING"
                                        ? "ACTIVE"
                                        : "PENDING",
                                  }
                                : z,
                            ),
                          );
                        })
                        .catch(() => {});
                    } else {
                      changeStatus(
                        x.data.id,
                        x.data.status === "PENDING" ? "ACTIVE" : "PENDING",
                      )
                        .then(() => {
                          if (x.data.status === "PENDING")
                            toast.success("اجازه دسترسی با موفقیت انجام شد");
                          else toast.success("لغو دسترسی با موفقیت انجام شد");

                          setRowData((data) => {
                            return data.map((z) =>
                              z.id === x.data.id
                                ? {
                                    ...z,
                                    status:
                                      x.data.status === "PENDING"
                                        ? "ACTIVE"
                                        : "PENDING",
                                  }
                                : z,
                            );
                          });
                        })
                        .catch(() => {});
                    }
                  }}
                >
                  <AccessibilityIcon color="white" size="0.7" />
                  <Typography
                    fontFamily="Vazirmatn"
                    color="white"
                    fontSize="13px"
                  >
                    {x.data.status === "PENDING"
                      ? "اجازه دسترسی"
                      : "لغو دسترسی"}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => {
                    if (selected === 4) {
                      getGroupLeaderInfo(x.data.id)
                        .then((z) => {
                          setDataMyInfo(z);
                          setOpenProfilePop(true);
                        })
                        .catch(() => {});
                      setGroupInfo(false);
                    } else {
                      getGroupAdminInfo(x.data.id)
                        .then((z) => {
                          setDataMyInfo(z);
                          setOpenProfilePop(true);
                        })
                        .catch(() => {});
                      setGroupInfo(false);
                    }
                  }}
                  sx={{
                    ":hover": { bgcolor: "#A2E5C5" },
                  }}
                >
                  <EyeOpenIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    if (selected === 4) {
                      generateTempCodeForGroup(x.data.id)
                        .then((y) => {
                          navigator.clipboard.writeText(y);
                          toast.success("کد موقت کپی شد!");
                        })
                        .catch(() => {});
                      return;
                    }
                    generateTempCode(x.data.id)
                      .then((y) => {
                        navigator.clipboard.writeText(y);
                        toast.success("کد موقت کپی شد!");
                      })
                      .catch(() => {});
                  }}
                  sx={{
                    ":hover": { bgcolor: "#A2E5C5" },
                  }}
                >
                  <LockIcon />
                </IconButton>
              </Grid>
            );
          },
        },
      ],
      [
        {
          field: "name",
          headerName: "نام و نام خانوادگی",
          width: 200,
          headerCheckboxSelection: true,
          checkboxSelection: true,
        },
        {
          field: "groupName",
          headerName: "نام گروه",
          width: 130,
        },
        {
          field: "nid",
          headerName: "کد ملی",
          width: 120,
        },
        {
          field: "phone",
          headerName: "شماره تلفن مسئول",
          width: 170,
        },
        {
          field: "tel",
          headerName: "شماره تلفن ثابت",
          width: 150,
        },
        {
          headerName: "عملیات",
          width: 300,
          cellRenderer: (x) => {
            return (
              <Grid key={`op_${x.id}`} display={"flex"} gap={"5px"}>
                <Box
                  bgcolor={
                    x.data.status === "PENDING" || x.data.status === "PENDING"
                      ? "#682C54"
                      : "#F05542"
                  }
                  gap="9px"
                  width="fit-content"
                  px="9px"
                  display="flex"
                  alignItems="center"
                  borderRadius="9px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    changeStatus(
                      x.data.id,
                      x.data.status === "PENDING" ? "ACTIVE" : "PENDING",
                    )
                      .then(() => {
                        setRowData((data) => {
                          return data.map((z) =>
                            z.id === x.data.id
                              ? {
                                  ...z,
                                  status:
                                    x.data.status === "PENDING"
                                      ? "ACTIVE"
                                      : "PENDING",
                                }
                              : { ...z },
                          );
                        });
                      })
                      .catch(() => {});
                  }}
                >
                  <AccessibilityIcon color="white" size="0.7" />
                  <Typography
                    fontFamily="Vazirmatn"
                    color="white"
                    fontSize="13px"
                  >
                    {x.data.status === "pending" || x.data.status === "PENDING"
                      ? "اجازه دسترسی"
                      : "لغو دسترسی"}
                  </Typography>
                </Box>
                {x.data.status === "ACTIVE" && (
                  <Box
                    bgcolor={
                      x.data.groupStatus === "PENDING" ||
                      x.data.groupStatus === "PENDING"
                        ? "green"
                        : "red"
                    }
                    gap="9px"
                    width="fit-content"
                    px="9px"
                    py="2px"
                    mr="5px"
                    display="flex"
                    alignItems="center"
                    borderRadius="9px"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      changeStatusGroup(x.data.id)
                        .then(() => {
                          setRowData((data) => {
                            return data.map((z) =>
                              z.id === x.data.id
                                ? {
                                    ...z,
                                    groupStatus:
                                      x.data.groupStatus === "PENDING"
                                        ? "ACTIVE"
                                        : "PENDING",
                                  }
                                : { ...z },
                            );
                          });
                        })
                        .catch(() => {});
                    }}
                  >
                    {/* <AccessibilityIcon color="white" size="0.7" /> */}
                    <Typography
                      fontFamily="Vazirmatn"
                      color="white"
                      fontSize="14px"
                    >
                      {x.data.groupStatus === "pending" ||
                      x.data.groupStatus === "PENDING"
                        ? "تایید گروه"
                        : "رد گروه"}
                    </Typography>
                  </Box>
                )}
                <IconButton
                  onClick={() => {
                    getGroupAdminInfo(x.data.id)
                      .then((z) => {
                        setDataMyInfo(z);
                        setOpenProfilePop(true);
                      })
                      .catch(() => {});
                    setGroupInfo(true);
                  }}
                  sx={{
                    ":hover": { bgcolor: "#A2E5C5" },
                  }}
                >
                  <EyeOpenIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    generateTempCode(x.data.id)
                      .then((y) => {
                        navigator.clipboard.writeText(y);
                        toast.success("کد موقت کپی شد!");
                      })
                      .catch(() => {});
                  }}
                  sx={{
                    ":hover": { bgcolor: "#A2E5C5" },
                  }}
                >
                  <LockIcon />
                </IconButton>
              </Grid>
            );
          },
        },
      ],
    ],
    [getToken(), bloodTypeKeyVals, selected],
  );

  const fetchUsers = useCallback(
    (clearSearch) => {
      if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;

      const query = new URLSearchParams();
      query.append("pageIndex", pageable.pageIndex);
      query.append("pageSize", pageable.pageSize);
      if (!clearSearch && valueSearch && valueSearch.length > 1) {
        query.append("searchKey", valueSearch);
      }

      setLoading(true);
      if (selected === 1) {
        query.append("justGroupRequests", false);
      }
      if (selected === 2) {
        query.append("justGroupRequests", true);
      }
      if (selected === 3) {
        query.append("groupName", dataGroup.name);
      }

      if (selected === 1 || selected === 2 || selected === 3) {
        getAdmins(query.toString())
          .then((x) => {
            setLastFetch(Date.now());
            setRowData(x.content);
            setTotalSize(x.totalElements);
          })
          .catch(() => {})
          .finally(() => setLoading(false));
      }
      if (selected === 4) {
        getGroupsUsers(query.toString())
          .then((x) => {
            setLastFetch(Date.now());
            setRowData(x.content);
            setTotalSize(x.totalElements);
          })
          .catch((z) => console.log(z))
          .finally(() => setLoading(false));
      }
    },
    [selected, lastFetch, pageable, valueSearch],
  );

  useEffect(() => {
    fetchUsers();
  }, [selected, pageable]);

  const [timer, setTimer] = useState();

  useEffect(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }

    if (valueSearch.length >= 2) {
      const timer = setTimeout(() => {
        setPageable({
          pageIndex: 0,
          pageSize: pageable.pageSize,
        });
        fetchUsers(false);
      }, 500);

      setTimer(timer);
    }

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    };
  }, [valueSearch]);

  return (
    <>
      <ViewProfile
        view
        groupInfo={groupInfo}
        image={image}
        setImage={setImage}
        setDataMyInfo={setDataMyInfo}
        dataMyInfo={dataMyInfo}
        setShow={setOpenProfilePop}
        show={openProfilePop}
      />
      {loading && <Loader />}
      <Grid
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        padding={"10px"}
      >
        <Grid display={"flex"} flexDirection={"row"}>
          <SearchInput
            type="text"
            id="filter-text-box"
            value={valueSearch}
            onChange={(e) => setValueSearch(e.target.value)}
            mb="10px"
          />
          {valueSearch.length >= 2 && (
            <Button
              sx={{ fontFamily: "Vazirmatn" }}
              onClick={() => {
                setValueSearch("");
                fetchUsers(true);
              }}
            >
              پاک کردن فیلتر
            </Button>
          )}
        </Grid>
        <Button
          sx={{ fontFamily: "Vazirmatn" }}
          variant="outlined"
          onClick={() => {
            const query = new URLSearchParams();
            if (valueSearch && valueSearch.length > 1) {
              query.append("searchKey", valueSearch);
            }
            if (selected === 1) {
              query.append("justGroupRequests", false);
            }
            if (selected === 2) {
              query.append("justGroupRequests", true);
            }
            if (selected === 3) {
              query.append("groupName", dataGroup.name);
            }
            userReport(query)
              .then((x) => {
                const blob = new Blob([x], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `users.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
              })
              .catch(() => {});
          }}
        >
          خروجی اکسل
        </Button>
      </Grid>
      <CustomTable
        totalElements={totalSize}
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        pageSize={pageable.pageSize}
        currentPage={pageable.pageIndex}
        rowData={rowData}
        columns={selected === 2 ? colDefsGroups : colDefs}
        selection={selection}
        setSelection={(selectedItems) => {
          setSelection(selectedItems);
        }}
        clearSelection={clearSelectionFlag}
      />
      {selection.length >= 1 && (
        <SelectionFuncTable
          selected={selected}
          rowData={rowData}
          refetchData={() => {
            setClearSelectionFlag(true);
            setTimeout(() => {
              setClearSelectionFlag(false);
            }, 500);
            setSelection([]);
            fetchUsers(false);
          }}
          data={selection}
          count={selection.length}
          onClose={() => {
            setClearSelectionFlag(true);
            setTimeout(() => {
              setClearSelectionFlag(false);
            }, 500);
          }}
        />
      )}
      <Dialog
        open={selectedRow !== undefined}
        onClose={() => setSelectedRow(undefined)}
        PaperProps={{
          style: {
            backgroundColor: "white",
            borderRadius: "20px",
            boxShadow: "none",
            width: "600px",
            margin: "100px auto",
            padding: "30px",
          },
        }}
      >
        <Formik
          initialValues={{ oldTripsCount: selectedRow?.oldTripsCount ?? 0 }}
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          validateOnMount={false}
          onSubmit={async (values, actions) => {
            setOldTripsCount(selectedRow.id, {
              tripsCount: values.oldTripsCount,
            })
              .then((x) => {
                if (x !== null) {
                  toast.success("عملیات موردنظر با موفقیت انجام شد");
                  setRowData(
                    rowData.map((item) => {
                      if (item.id !== selectedRow.id) return item;
                      return {
                        ...item,
                        oldTripsCount: values.oldTripsCount,
                      };
                    }),
                  );
                  setSelectedRow(undefined);
                }
              })
              .catch(() => {})
              .finally(() => actions.setSubmitting(false));
          }}
        >
          {({ isSubmitting, submitForm }) => (
            <Form
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <AsarFormikInput
                label={"تعداد اردوهای پیشین شرکت کرده"}
                name="oldTripsCount"
                type="numeric"
              />
              {isSubmitting && <Loader />}
              {!isSubmitting && (
                <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
                  <Button
                    color="primary"
                    onClick={submitForm}
                    variant="contained"
                  >
                    تایید
                  </Button>
                  <Button color="error" variant="outlined">
                    انصراف
                  </Button>
                </Grid>
              )}
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  );
}
